import Vue from 'vue'
import attack from '../../request/request'
import { UCENTER } from '../requers_variable'
import axios from 'axios'

export default{
  /**
   * 格式化用户名
   *
   * @param {any} number
   * @returns
   */
  fromat_username(number) {
    let str = number.substr(4, 3),
      reg = new RegExp(str)
    return number.replace(reg, '***')
  },
  /**
   *
   * 校验用户名
   * @param {any} number
   * @returns
   */

  vertify_username(number) {
    let reg = /^1\d{10}$/,
      state = {
        type: 0,
        msg: ''
      };
    if (number == '') {
      state.type = 0;
      state.msg = '手机号码不能为空';
      return state
    } else if (!reg.test(number)) {
      state.type = 1;
      state.msg = '手机号码格式错误';
      return state
    } else {
      state.type = 2;
      state.msg = '手机号码格式正确';
      return state
    }
  },

  /**
   * 校验用户是否存在
   *
   * @param {any} number
   * @returns
   */
  exit_username(number) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/exist`,
        data: {
          username: number
        },
        success(rep) {
          resolve(false)
        },
        error(err) {
          resolve(true)
        }
      })
    })
  },
  /**
  * 校验用户是否存在
  *
  * @param {any} number
  * @returns
  */
 isexit_username(number) {
   return new Promise(function(resolve, reject) {
     attack({
       type: 'post',
       url: `${UCENTER}/account/isExist`,
       data: {
         username: number
       },
       success(rep) {
         resolve(true)
       },
       error(err) {
         resolve(false)
       }
     })
   })
 },
  /**
   * 校验密码格式
   *
   * @param {any} pwd
   * @returns
   */
  vertify_password(pwd) {
      const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,20}$/,
      state = {
        type: 0,
        msg: ''
      }
    if (pwd == '') {
      state.type = 0;
      state.msg = '密码不能为空';
      return state
    } else if (!reg.test(pwd)) {
      state.type = 1;
      state.msg = '请输入8-20位，至少包含大写字母，小写字母和数字';
      return state
    } else {
      state.type = 2;
      state.msg = '密码格式正确';
      return state
    }
  },

  /**
   * 校验密码有填写， 仅登录使用
   *
   * @param {any} pwd
   * @returns
   */
  vertify_password_for_login(pwd) {
    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,20}$/g,
      state = {
        type: 0,
        msg: ''
      }
    if (pwd == '') {
      state.type = 0;
      state.msg = '密码不能为空';
      return state
    }  else {
      state.type = 2;
      state.msg = '密码格式正确';
      return state
    }
  },
  /**
   * 校验密码是否一致
   *
   * @param {any} pwd
   * @param {any} check
   * @returns
   */
  vertify_accord(pwd, check) {
    let state = {
      type: 0,
      msg: ''
    }
    if (check == '') {
      state.type = 0;
      state.msg = '请再次输入密码';
      return state
    } else if (pwd != check) {
      state.type = 1;
      state.msg = '密码不一致';
      return state
    } else if (pwd == check) {
      state.type = 2;
      state.msg = '密码一致';
      return state
    }
  },
  /**
   * 校验用户名格式
   *
   * @param {any} name
   * @returns
   */
  vertify_name(name) {
    let reg = /^\S{2,50}$/g,
      state = {
        type: 0,
        msg: ''
      };
    if (name == '') {
      state.type = 0;
      state.msg = '输入您的姓名';
      return state
    } else if (!reg.test(name)) {
      state.type = 1;
      state.msg = '姓名格式错误,姓名长度应该在2-50个字符之间';
      return state
    } else {
      state.type = 2;
      state.msg = '姓名格式正确';
      return state
    }
  },
  /**
   * 不带验证码用户登录   *
   * @param {any} params
   * @returns
   */
  login(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/login`,
        data: params,
        success(rep) {
          sessionStorage.publicToken = rep.data.AccessToken
          sessionStorage.islogin = 'true'
          resolve({
            isok: true,
            msg: '登录成功'
          })
        },
        error(rep) {
          resolve({
            isok: false,
            msg: rep.message
          })
        }
      })
    })
  },
  /**
   * 带验证码用户登录
   *
   * @param {any} params
   * @returns
   */
  login_verity(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/verity/login`,
        data: params,
        success(rep) {
          sessionStorage.publicToken = rep.data.AccessToken
          sessionStorage.islogin = 'true'
          sessionStorage.currentLoginUser = (JSON.parse(rep.config.data)).username
          resolve({
            isok: true,
            msg: '登录成功'
          })
        },
        error(rep) {
          resolve({
            status: rep.status,
            isok: false,
            msg: rep.message
          })
        }
      })
    })
  },
  /**
   * 获取用户信息
   *
   * @returns
   */
  get_profile() {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${UCENTER}/account/profile`,
        success(rep) {
          resolve(rep.data)
        },
        error(rep) {
          resolve(false)
        }
      })
    })
  },
    /**
     * 获取用户的微信信息
     *
     * @returns
     */
    get_wechat_profile(params) {
        return new Promise(function(resolve, reject) {
            attack({
                type: 'get',
                url: `${UCENTER}/wechat/account/detail`,
                data: params,
                success(rep) {
                    resolve(rep.data)
                },
                error(rep) {
                    resolve(false)
                }
            })
        })
    },
    unbind_wechat(params) {
        return new Promise(function(resolve, reject) {
            attack({
                type: 'get',
                url: `${UCENTER}/wechat/account/delete`,
                data: params,
                success(rep) {
                    resolve(rep.data)
                },
                error(rep) {
                    resolve(false)
                }
            })
        })
    },
  /**
   * 用户注册
   *
   * @param {any} params
   * @returns
   */
  registry(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/register`,
        data: params,
        success(rep) {
          resolve(rep.data.status)
        },
        error(err) {
          resolve(false)
        }
      })
    })
  },

  // 重置密码
  rebackpasswd(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/rebackpasswd`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(rep) {
          resolve(false)
        }
      })
    })
  },

  /**
   * 注销
   *
   *
   */
  logout(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/logout`,
        data: params,
        success(rep) {
          sessionStorage.publicToken = ''
          sessionStorage.islogin = ''
          resolve(true)
        },
        error(rep) {
          if (rep.status == 403 || rep.status == 401) {
            sessionStorage.publicToken = ''
            sessionStorage.islogin = ''
            resolve(true)
            return
          }
          resolve(false)
        }
      })
    })
  },
  // 校验用户是否登录
  verity_login() {
    let loginState = sessionStorage.islogin
    if (loginState == 'true') {
      return true
    } else {
      return false
    }
  },
  /**
   * 机构管理 新增
   */
  create_mechanism(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/subject/create`,
        data: params,
        success(rep) {
          resolve(rep.data.status)
        },
        error(err) {
          resolve(err)
        }
      })
    })
  },
  // 修改密码
  changepasswd(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/changepasswd`,
        data: params,
        success(rep) {
          resolve({
            status: true
          })
        },
        error(rep) {
          resolve({
            status: false,
            code: '',
            msg: rep.message
          })
        }
      })
    })
  },

  // 修改账户信息
  modify(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/modify`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(rep) {
          resolve(false)
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/data/ucenter/account.js